import PropTypes from 'prop-types';
import React from 'react';

import PageSection from '../Common/PageSection';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './AgendaHeading.module.css';
import HeadingCtas from './HeadingCtas';

const AgendaHeading = ({ page, className, ctaClassName, children }) => {
  return (
    <PageSection noPad fullBleed>
      <div className={[styles.headerSection].join(' ')}>
        <div className={styles.backgroundImageWrapper}>
          {page.headingBackgroundImage && <img src={page.headingBackgroundImage.file.url} alt={'hero'} />}
        </div>
        <div className={styles.headingContentWrapper}>
          <div className={[styles.headingContent, className].join(' ')}>
            <h1 className={styles.heading}>{page.heading}</h1>
            <RichTextConverter copy={page.headingIntroCopy} className={styles.paragraph} />
            {children}
            {page.headingCtAs && (
              <HeadingCtas
                bkColor={'pink'}
                className={[styles.headingButton, ctaClassName].join(' ')}
                ctas={page.headingCtAs}
              />
            )}
          </div>
        </div>
      </div>
    </PageSection>
  );
};

AgendaHeading.propTypes = {
  page: PropTypes.object,
};

export default AgendaHeading;
